export const jobBoards = [
  'Dice',
  'Tech Fetch',
  'Career Builder',
  'Career Builder Edge',
  'Monster Classic',
  'Monster Power Search',
  'Monster EU',
  'JobServe',
  'CW Jobs',
  'CV Library',
  'JobSite',
];
